import { useState } from 'react';
import Picker from 'emoji-picker-react';
import PropTypes from 'prop-types';

export const EmojiPicker = ({ onSelect }) => {

    const [showPicker, setShowPicker] = useState(false);

    const onEmojiClick = (event, emojiObject) => {
        onSelect(emojiObject.emoji);
    };

    return (
        <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                setShowPicker(!showPicker);
            }}>
                <path d="M12 0C5.38147 0 0 5.38155 0 12C0 18.6186 5.38147 24 12 24C18.6185 24 24 18.6186 24 12C24 5.38155 18.6185 0 12 0ZM12 1.5C17.8079 1.5 22.5 6.19215 22.5 12C22.5 17.8078 17.8079 22.5 12 22.5C6.19213 22.5 1.5 17.8078 1.5 12C1.5 6.19215 6.19213 1.5 12 1.5ZM8.25 7.5C7.85218 7.5 7.47065 7.65804 7.18934 7.93934C6.90804 8.22065 6.75 8.60218 6.75 9C6.75 9.39782 6.90804 9.77935 7.18934 10.0607C7.47065 10.342 7.85218 10.5 8.25 10.5C8.64782 10.5 9.02935 10.342 9.31066 10.0607C9.59196 9.77935 9.75 9.39782 9.75 9C9.75 8.60218 9.59196 8.22065 9.31066 7.93934C9.02935 7.65804 8.64782 7.5 8.25 7.5ZM15.75 7.5C15.3522 7.5 14.9706 7.65804 14.6893 7.93934C14.408 8.22065 14.25 8.60218 14.25 9C14.25 9.39782 14.408 9.77935 14.6893 10.0607C14.9706 10.342 15.3522 10.5 15.75 10.5C16.1478 10.5 16.5294 10.342 16.8107 10.0607C17.092 9.77935 17.25 9.39782 17.25 9C17.25 8.60218 17.092 8.22065 16.8107 7.93934C16.5294 7.65804 16.1478 7.5 15.75 7.5ZM6 13.5C5.9998 14.5534 6.27694 15.5883 6.80356 16.5006C7.33018 17.413 8.08772 18.1706 9 18.6973C9.91212 19.2239 10.9468 19.5011 12 19.5011C13.0532 19.5011 14.0879 19.2239 15 18.6973C15.9123 18.1706 16.6698 17.413 17.1964 16.5006C17.7231 15.5883 18.0002 14.5534 18 13.5H6Z" fill="#303C42" />
            </svg>

            {
                showPicker && (
                    <div className='fixed left-0 z-50' style={{ bottom: '100px' }}>
                        <Picker onEmojiClick={onEmojiClick} />
                    </div>
                )
            }
        </>
    );
};


EmojiPicker.propTypes = {
    onSelect: PropTypes.func
}